import { render, staticRenderFns } from "./searchWord.vue?vue&type=template&id=6695c468&scoped=true&"
import script from "./searchWord.vue?vue&type=script&lang=js&"
export * from "./searchWord.vue?vue&type=script&lang=js&"
import style0 from "./searchWord.vue?vue&type=style&index=0&id=6695c468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6695c468",
  null
  
)

export default component.exports